import { render, staticRenderFns } from "./puntos.vue?vue&type=template&id=019b7166"
import script from "./puntos.vue?vue&type=script&lang=js"
export * from "./puntos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports